/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { GcsSourceProperties } from '../models/GcsSourceProperties';
import { IngestionSourceType } from '../models/IngestionSourceType';
import { S3SourceProperties } from '../models/S3SourceProperties';

export class UpdateIngestionPipelineInput {
  /**
  * The name of the ingestion pipeline
  */
  'name': string;
  /**
  * The namespace for the ingestion pipeline
  */
  'namespace': string;
  /**
  * The table name for the ingestion pipeline
  */
  'tableName': string;
  'sourceType': IngestionSourceType;
  's3SourceProperties'?: S3SourceProperties;
  'gcsSourceProperties'?: GcsSourceProperties;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "namespace",
      "baseName": "namespace",
      "type": "string",
      "format": ""
    },
    {
      "name": "tableName",
      "baseName": "tableName",
      "type": "string",
      "format": ""
    },
    {
      "name": "sourceType",
      "baseName": "sourceType",
      "type": "IngestionSourceType",
      "format": ""
    },
    {
      "name": "s3SourceProperties",
      "baseName": "s3SourceProperties",
      "type": "S3SourceProperties",
      "format": ""
    },
    {
      "name": "gcsSourceProperties",
      "baseName": "gcsSourceProperties",
      "type": "GcsSourceProperties",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return UpdateIngestionPipelineInput.attributeTypeMap;
  }

  public constructor() {
  }
}



